module.exports = __webpack_public_path__ + "img/Assurance-Extra-Income-Cover.fc392f2c.jpg";